import BiggerPicture from 'bigger-picture';

const bp = BiggerPicture({
    target: document.body,
});
const windowWidth = window.innerWidth;

let formHtml;

if (windowWidth < 740) {
    formHtml = [
        {
            html:
                '<div id="form-modal" class="bg-green-2 rounded-3xl p-8 m-8 z-2k" style="height:auto;width:90vw;overflow:scroll;"><h3 class="mb-4">Get in touch</h3></div>',
        },
    ];
} else {
    formHtml = [
        {
            html:
                '<div id="form-modal" class="bg-green-2 rounded-3xl p-8 z-2k" style="max-height:100vh;height:664px;width:739px;overflow:scroll;"><h3 class="mb-4">Get in touch</h3></div>',
        },
    ];
}

// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
const keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

const preventDefault = (e) => {
    e.preventDefault();
};

const preventDefaultForScrollKeys = (e) => {
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
};

// modern Chrome requires { passive: false } when adding event
let supportsPassive = false;
try {
    window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
        get() {
            supportsPassive = true;
        },
    }));
} catch (e) { }

const wheelOpt = supportsPassive ? { passive: false } : false;
const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

const closeContactForm = () => {
    window.removeEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.removeEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
};

const openContactForm = () => {

    bp.open({
        items: formHtml,
        onClose: () => {
            if (windowWidth >= 740) {
                closeContactForm();
            }
        },
        onOpen: (container) => {
            const style = document.createElement('style');
            style.innerHTML = `
              .bp-x::before {
                content: '' !important;
              },
            `;
            document.head.appendChild(style);
            const closeBtn = container.querySelector('.bp-x');
            closeBtn.innerHTML = '<svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">\n'
                + '    <line x1="2.04937" y1="1.95057" x2="21.0494" y2="20.9506" stroke="#FFFFFF" stroke-width="2.96823"/>\n'
                + '    <line x1="1.51515" y1="20.9508" x2="20.5151" y2="1.95081" stroke="#FFFFFF" stroke-width="2.96823"/>\n'
                + '</svg>';
            closeBtn.style.width = '23px';
            closeBtn.style.height = '26px';
            closeBtn.style.top = '10px';
            closeBtn.style.right = '10px';
            closeBtn.style.background = 'none';
            closeBtn.addEventListener('click', closeContactForm); // mobile click

            // Inject and execute the Cognito Forms script
            const script = document.createElement('script');
            script.src = 'https://www.cognitoforms.com/f/seamless.js';
            script.setAttribute('data-key', 'uszJPYvybkKcxdWegb_UKQ');
            script.setAttribute('data-form', '1');
            const formModal = document.querySelector('#form-modal');
            formModal.appendChild(script);
            // if (windowWidth >= 740) {
            //     window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
            //     window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
            //     window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
            //     window.addEventListener('keydown', preventDefaultForScrollKeys, false);
            // }
        },
    });
};

const contactFormInit = () => {
    const contactFormBtns = document.querySelectorAll('[data-contact-form]');
    contactFormBtns.forEach(btn => {
        btn.addEventListener('click', openContactForm); // mobile click
    });
};

contactFormInit();
